export const heroData = {
  badge: "ASCENCIO GROUP",
  headline: "Fill Your Calendar With High-Value Clients.",
  subheadline:
    "Strategic marketing agency for Aesthetic Clinics ready to scale beyond word-of-mouth.",
  buttons: [
    {
      text: "Show Me How It Works",
      variant: "primary",
      link: "/how-it-works",
    },
    {
      text: "Services",
      variant: "secondary",
      link: "#services",
    },
  ],
  backgroundImage: require("../assets/images/hero/staircase.png"),
};
